import { RichText as RichTextData } from '@/payload-types'
import RenderRichTexComponent from '@/components/rich-text-render/richTextRender'
import { CreateAnchorLink } from '@/lib/postFunctions'

interface IProps {
  richTextData: RichTextData | null
}

export const RichTextComponent = ({ richTextData }: IProps) => {
  const link = richTextData ? CreateAnchorLink(richTextData)?.href?.split('#')[1] : null
  return (
    <RenderRichTexComponent richTextField={richTextData?.richText} anochrLink={link ? link : ''} />
  )
}

export default RichTextComponent
